import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section id="faq" className="py-16 md:py-20" data-id="element-87" data-mp="1cf04tedxfaok">
      <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-88" data-mp="1cgb7favmyce3">
        <Reveal data-id="element-89" data-mp="2a175web0ukw6">
          <Eyebrow data-id="element-90" data-mp="2a1qj5hpq8l3v">FAQs</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl" data-id="element-91" data-mp="2535qc3ct13pg">
            Everything you might ask
          </h2>
          <p className="mt-4 text-base text-forest/70" data-id="element-92" data-mp="202rf6cfwpdn7">
            Still curious? Reach out and our wellness team will help.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="divide-y divide-forest/12 border-t border-forest/12" data-id="element-93" data-mp="oonqnls38hpj">
          {FAQS.map((faq, i) => <div key={faq.q} data-id="element-94" data-mp="jorhl84ja034" data-mpi={i}>
              <button onClick={() => setOpen(open === i ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left" aria-expanded={open === i} data-id="element-95" data-mp="johvhvmm0d2p">
                <span className="font-serif text-lg text-forest" data-id="element-96" data-mp="1apsuguj3zl9t">{faq.q}</span>
                <PlusIcon className={`h-5 w-5 shrink-0 text-sage transition-transform duration-300 ${open === i ? 'rotate-45' : ''}`} data-id="element-97" data-mp="1arww15tjc86x" />
              </button>
              <AnimatePresence initial={false} data-id="element-98" data-mp="16oh4up08j01m">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1]
            }} className="overflow-hidden" data-id="element-99" data-mp="rzb58zxhj7t7">
                    <p className="pb-6 pr-8 text-base leading-relaxed text-forest/70" data-id="element-100" data-mp="mzgf4yljam97">{faq.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </Reveal>
      </div>
    </Section>;
}